import React from "react";
import { useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import { loaderMsg, loadertype } from "../../constants";
import Loader from "react-loaders";
import { getPaymntGistory } from "../../util/APIUtils";
import CategoryBody from "./CategoryBody";
import RecurringExpBody from "./RecurringExpBody";

export default function RecurringExp() {
  const [values, setValues] = useState({
    frmDate: new Date().toISOString().substring(0, 10),
    toDate: new Date().toISOString().substring(0, 10),
  });
  const [trans, setTrans] = useState([]);
  const [block, setBlock] = useState(false);

  useEffect(() => {
    loadReqData();
  }, []);

  const loadReqData = () => {
    setBlock(true);
    getPaymntGistory(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  return (
    <BlockUi
      tag="div"
      blocking={block}
      loader={<Loader active type={loadertype} color="#8dc63f" />}
      message={loaderMsg}
    >
      <div className="animated fadeIn">
        <RecurringExpBody data={trans} />
      </div>
    </BlockUi>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/RecurringExp.js